import _ from "lodash";
import Errors from "../../../utils/Errors";
import {basicContext} from "../../../utils/contextUtils";
const {generateFetchFieldListAction} = require('../../../../apps/KpModule/actions/api')

// Déploiement d'une solution industrialisée chez un client : un seul par couple (solution, client)
export const entity = {
    name: 'Deployment',
    facets: ['conversations'],
    fields: [
        {path: 'product', type: 'Product', unique: true, uniqueWith: 'client'},
        {path: 'client', type: 'GroupAndCompany'},
        {path: 'contacts', type: 'Contact', link: 'MTM', nullable: true},
        {path: 'status', type: 'DeploymentStatus'},
        {path: 'goLiveDate', type: 'date', nullable: true},
        {path: 'endDate', type: 'date', nullable: true},
        'description',
        {
            path: 'fullName',
            fieldPath: ['product.code', 'client.name'],
            f: function() {
                return `${_.get(this, 'product.code', '')} - ${_.get(this, 'client.name', '')}`
            }
        }
    ],
    filters: [
        {
            name: 'byProduct',
            isDefault: false,
            query: function(context) {
                const productId = _.get(context.data, 'product.id')
                return productId ? {product: new global.ObjectID(productId)} : {_id: null}
            }
        }
    ],
    beforeSave: async function(newObject, oldObject, context, callback) {
        try {
            const product = await global.app.K.Product.get(
                {_id: new global.ObjectID(newObject.product.id)},
                {...basicContext(context), fieldPath: ['kind']}
            )
            if (_.get(product, 'kind.id') !== 'solution') {
                return callback(new Errors.ValidationError(context.tc('deploymentRequiresSolution')))
            }
            callback(null, newObject, oldObject)
        } catch (error) {
            callback(error)
        }
    }
}

export const module_ = {
    object: 'Deployment',
    category: {
        path: 'catalog',
        icon: 'package'
    },
    defaultSortBy: 'goLiveDate',
    defaultSortDirection: 'DESC',
    viewMap: {
        dt: [
            {path: 'product', display: 'fullName'},
            {path: 'client', display: 'fullName'},
            'status',
            'goLiveDate',
            {path: 'endDate', initiallyNotVisible: true}
        ],
        form: [
            {
                path: 'product',
                display: 'fullName',
                filters: ['onlySolutions'],
                placeholder: 'sélectionner la solution déployée'
            },
            {
                path: 'client',
                display: 'fullName',
                placeholder: 'sélectionner le client',
                subscriptions: {
                    onChange: (newValue, oldValue, {store}) => {
                        store.dispatch(
                            generateFetchFieldListAction(
                                'm-K-deployment.Deployment_contacts',
                                store.getState,
                                {data: {groupAndCompany: {id: newValue?.id}}}
                            )
                        )
                    }
                }
            },
            {path: 'contacts', tKey: 'interlocutor', filters: ['byGroupAndCompany']},
            {path: 'status', default: {id: 'setup'}},
            'goLiveDate',
            'endDate',
            {path: 'description', tKey: 'synthèse', type: 'richTextEditor'},
            {path: 'conversations', tKey: 'suivi'}
        ]
    },
    filters: [
        {
            path: 'product',
            object: 'Product',
            display: 'fullName',
            client: true,
            clearable: true,
            placeholder: 'selectProduct',
            default: {id: null},
            query: function(context) {
                const productId = _.get(context.data, 'product.id')
                return productId ? {product: new global.ObjectID(productId)} : {}
            }
        }
    ]
}
